function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );

    if (this.dataset.type === 'kit') {
      this.getProductKitFunctions = this.closest('product-kit-functions');
    }
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
    if (this.dataset.type === 'kit') this.getProductKitFunctions.initClass();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ModifyCollectionGrid extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.button__collection-type-grid');
    this.changeCollection = this.changeCollection.bind(this);
    this.initialize();
  }

  initialize() {
    if (this.button) {
      this.button.removeEventListener('click', this.changeCollection);
      this.button.addEventListener('click', this.changeCollection);
    }
  }

  changeCollection() {
    this.containerCollection = document.querySelector('.product-grid-container .grid');

    if (this.containerCollection) {
      this.containerCollection.classList.toggle('grid--1-col-tablet-down');
      this.containerCollection.classList.toggle('grid--2-col-tablet-down');
    }

    this.button.classList.toggle('one-block');
  }

  reinitializeListeners() {
    this.initialize();
  }
}

customElements.define('modify-collection-grid', ModifyCollectionGrid);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();

    this.listMenuItems = this.mainDetailsToggle.querySelectorAll('.menu-drawer__menu.first-level > li > details');
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.slider-line-arrow)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    if (event.currentTarget.classList.contains('header__icon')) {
      this.listMenuItems[0].setAttribute('open', true);
      this.listMenuItems[0].classList.add('menu-opening');
    } else if (event.currentTarget.classList.contains('menu-drawer__menu-item', 'summary-fisrt-level')) {
      // Cierra los otros ítems de primer nivel; el tocado lo resuelve el toggle nativo del summary.
      this.listMenuItems.forEach((item) => {
        if (item === event.currentTarget.parentNode) return;
        item.removeAttribute('open')
        item.classList.remove('menu-opening')
      });
    }

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      // Ítem ya abierto: si tiene destino real (data-href) el toque navega; si no, lo cierra
      // por el mismo camino que el botón de cerrar. Cerrado, el toque siempre abre.
      if (isOpen) {
        event.preventDefault();
        if (summaryElement.dataset.href) {
          window.location.href = summaryElement.dataset.href;
          return;
        }
        this.closeSubmenu(detailsElement);
        return;
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);

    const modifyCollectionGrid = document.querySelector('modify-collection-grid');
    if (modifyCollectionGrid) {
      modifyCollectionGrid.reinitializeListeners();
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.sliderLineMenuMobile = this.querySelector('.content-items__slider-line-items');
    this.buttonHeaderIcon = this.querySelector('.header__icon')
    this.buttonSliderPrev = this.querySelector('button[name="previous"]')
    this.buttonSliderNext = this.querySelector('button[name="next"]')
  }

  openMenuDrawer(summaryElement) {
    if (this.sliderLineMenuMobile) {
      setTimeout(()=> {
        const getWidthDisplay = window.innerWidth < 750 ? window.innerWidth : 400
        if (this.sliderLineMenuMobile.scrollWidth > getWidthDisplay - 30) {
          this.buttonSliderPrev.classList.remove('hidden')
          this.buttonSliderNext.classList.remove('hidden')
          this.sliderLineMenuMobile.closest('.container__slider-line-menu').style.padding = 0;
        }
      }, 250)
    }

    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    this.navigation = this.querySelector('.menu-drawer-first-level-links')
    this.listLinkContent = this.querySelectorAll('[id^="Details-menu-drawer"] > .menu-drawer__submenu')

    if (this.listLinkContent && this.navigation) {
      this.listLinkContent.forEach((item) => {
        item.style.minHeight = `calc(100% - ${this.navigation.offsetHeight}px)`;
        item.style.top = this.navigation.offsetHeight + 'px';
      })
    }
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');

    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    if (this.sliderControlWrapper) {
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    }

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: 'smooth'
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'smooth'
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;

    let isLastSlide
    const getLastElement = this.sliderItems[this.sliderItems.length - 1]

    if (getLastElement && Math.round(getLastElement.getBoundingClientRect().right) <= Math.round(this.slider.getBoundingClientRect().right)) {
      isLastSlide = this.currentPage;
    } else {
      isLastSlide = this.currentPage === this.sliderItemsToShow.length;
    }

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
        behavior: 'smooth'
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'smooth'
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);


class ProductKitFunctions extends HTMLElement {
  constructor() {
    super()
    this.items = []
    this.initClass();
  }

  initClass() {
    this.productKitAddEventInput();
    this.productKitupdatedPrice();
    this.productKitUpdateItems();
    this.productKitAddEventButton();
  }

  productKitAddEventInput() {
    const productsInputs = document.querySelectorAll('.product-kit-block .product-form__input input[type="radio"]');
    productsInputs.forEach((element) => {
      if (element.dataset.event === false) {
        element.setAttribute('data-event', true);
        element.addEventListener('change', this.eventUpdate);
      }
    });
  }

  productKitupdatedPrice() {
    const getProductPrice = Array.from(document.querySelectorAll('.product-kit-block__list .pr_grid_item .price__sale .price-item--last'));
    const getMainPrice = document.querySelector('.product product-info [id^="price-"]');
    const getQuantityValue = Number(document.querySelector('.product-kit-block__container-button-and-quantity quantity-input input[name="quantity"]').value);

    const totalPrice = getProductPrice.reduce((acc, current) => {
      return acc + Number(current.innerText.replace('R$', '').replace(',', '.').trim())
    }, 0)

    const formatFinalPrice = Number(totalPrice * getQuantityValue).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    getMainPrice.querySelector('.price__regular .price-item').innerText = formatFinalPrice;
    getMainPrice.classList.remove('visibility-hidden');
  }

  productKitUpdateItems() {
    const getQuantityValue = document.querySelector('.product-kit-block quantity-input input[name="quantity"]')

    this.items = []
    const productOptionsSelected = document.querySelectorAll('.pr_grid_item input[name="id"]')

    productOptionsSelected.forEach(element => {
      this.items.push({
        'id': element.value,
        'name': element.dataset.name,
        'quantity': getQuantityValue.value ? getQuantityValue.value : 1
      })
    })

    bundleProductKit.changeVariant = function (variant, index) {
      this.items[index].id = variant.id + ''
    }
  }

  productKitAddEventButton() {
    document.querySelectorAll('.add-bundle-to-cart').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
  
        let formData = ({
          items: this.items
        })
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(formData)
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch((e) => {
            console.error(e);
          })
      })
    })
  }
  
  handleErrorMessage(errorMessage) {
    let errorMessageWrapper = document.querySelector('.buy-together-form__error-message-wrapper');
    if (!errorMessageWrapper) return;
    let errorMessageDiv = errorMessageWrapper.querySelector('.buy-together-form__error-message');

    errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      errorMessageDiv.textContent = errorMessage;
    }
  }
}

customElements.define('product-kit-functions', ProductKitFunctions);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.dataType = this.dataset.type;

    if (this.dataset.section.includes('buy-together')) {
      this.querySelectorAll('select, fieldset').forEach((element) => {
        const isRadioSize = element.tagName === 'FIELDSET' ? true : false;
        const isSelectSize = element.tagName === 'SELECT' ? true : false;
        const isDesktop = window.innerWidth >= 990 ? true : false;

        if (isRadioSize && !isDesktop && element.classList.contains('type--tamanho')) element.remove();
        else if (isSelectSize && isDesktop && element.classList.contains('type--tamanho')) element.remove();
      }) 
    }

    if (this.dataset.type === 'kit') {
      this.getProductKitFunctions = this.closest('product-kit-functions');
      this.getProductKitFunctions.initClass();
    }
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false' || this.dataType == 'card' || this.dataType == 'kit') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    let sectionId
    let fetchUrl
    let getSpinner

    const getSpinnerClosest = this.closest('.card-wrapper');
    if (getSpinnerClosest) getSpinner = getSpinnerClosest.querySelector('.card__inner .card__media .loading__spinner');

    if (this.dataType === 'card' || this.dataType === 'kit' || this.dataset.section.includes('buy-together')) {
      if (getSpinner) getSpinner.classList.remove('hidden');
      fetchUrl = `${this.dataset.url}?variant=${requestedVariantId}`
    } else {
      sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
      fetchUrl = `${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`
    }

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;
        const getHtml = new DOMParser().parseFromString(responseText, 'text/html');
        let html;
        
        if (this.dataType === 'card') {
          html = getHtml.querySelector('#MainContent').querySelector('[id^="MainProduct-"]');
          sectionId = html.dataset.section;

          if (this.currentVariant && this.currentVariant.featured_media) {
            const getModal = html.querySelector(`#ProductModal-${sectionId} img[data-media-id="${this.currentVariant.featured_media.id}"]`);
            const getModalSrc = getModal?.src.split('width=')[0].concat('width=');
            const getImgCard = this.closest('.card-wrapper').querySelector('.card__inner .card__media img:first-child');
  
            const newSrcset = `
              ${getModalSrc}165 165w,
              ${getModalSrc}360 360w,
              ${getModalSrc}533 533w,
              ${getModalSrc}720 720w,
              ${getModalSrc}940 940w,
              ${getModalSrc}1066 1066w,
              ${getModalSrc} 2000w
            `;
    
            getImgCard.setAttribute('srcset', newSrcset);
            getImgCard.setAttribute('src', getModalSrc);
          }

          if (this.currentVariant && this.currentVariant.price) {
            const getVariantPrice = this.currentVariant.price / 100;
            const getVariantCompareAtPrice = this.currentVariant.compare_at_price / 100;
            const getCardPrice = this.closest('.card-wrapper').querySelector('.price__sale .price-item--sale');
            const getCardCompareAtPrice = this.closest('.card-wrapper').querySelector('.price__sale .price-item--regular');

            if (getVariantCompareAtPrice && getVariantCompareAtPrice > getVariantPrice) {
              getCardCompareAtPrice.style.display = 'inline-block';
              getCardPrice.innerText = getVariantPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
              getCardCompareAtPrice.innerText = getVariantCompareAtPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            } else {
              getCardPrice.innerText = getVariantPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
              getCardCompareAtPrice.style.display = 'none';
            }
          }

          if (getSpinner) getSpinner.classList.add('hidden');
        } else if (this.dataType === 'kit') {
          html = getHtml.querySelector('#MainContent').querySelector('[id^="MainProduct-"]');

          const getOldPrice = this.closest('li').querySelector('.price');
          const getNewPrice = html.querySelector('[id^="ProductInfo"]').querySelector('[id^="price-"]');
          if (getOldPrice && getNewPrice) getOldPrice.innerHTML = getNewPrice.innerHTML;

          const oldProductId = this.closest('li').querySelector('.product-kit-block__main-information .product-form input[name="id"]');
          const newProductId = html.querySelector('[id^="ProductInfo"] .container__buy-buttons input[name="id"]');

          if (oldProductId && newProductId) {
            oldProductId.value = newProductId.value;
            oldProductId.setAttribute('data-name', newProductId.dataset.name);
          }
        } else {
          html = getHtml;
        }

        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.querySelector(`#price-${sectionId}`);
        const skuSource = html.querySelector(`#Sku-${sectionId}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.querySelector(`#Inventory-${sectionId}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.querySelector(`#Volume-${sectionId}`);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.querySelector(`#Price-Per-Item-${sectionId}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.querySelector(`#ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        if (this.dataType !== 'kit' && this.dataType !== 'card') {
          const floatingButton = document.querySelector('.product-form__floating-button button[type="submit"]');
          const getFinalPrice = source?.querySelector('.price__sale .price-item--last');
  
          if (floatingButton) {
            const floatingButtonSpan = document.querySelector('.product-form__floating-button button[type="submit"] span');
  
            if (!addButtonUpdated.hasAttribute('disabled')) {
              floatingButtonSpan.innerHTML = `${window.variantStrings.addToCart} - <strong>${getFinalPrice.innerHTML}</strong>`;
              floatingButton.removeAttribute('disabled');
            } else {
              floatingButtonSpan.innerHTML = window.variantStrings.soldOut;
              floatingButton.setAttribute('disabled', true);
            }
          }
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });

        if (this.dataType === 'kit') this.getProductKitFunctions.initClass();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);


class ProductGroupSelects extends HTMLElement {
  constructor() {
    super();
    this.swatchProducts = this.querySelectorAll('.swatch-input__label');

    this.swatchProducts.forEach((item) => {
      item.addEventListener('click', this.onVariantChange.bind(this));
    })

    if (this.dataset.type === 'kit') {
      this.getProductKitFunctions = this.closest('product-kit-functions');
      this.getProductKitFunctions.initClass();
    }
  }

  onVariantChange(event) {
    this.renderProductInfo(event);
  }

  renderProductInfo(event) {
    this.clickedLabel = event.target.closest('label').title;
    let clickedInput = this.querySelector('fieldset').querySelector(`input[name="url-product--${this.clickedLabel}"]`).value;

    fetch(`${clickedInput}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('#MainContent').querySelector('[id^="MainProduct-"]')

        const getModal = html?.querySelector(`[id^="ProductModal-"] img`);
        const getModalSrc = getModal?.src.split('width=')[0].concat('width=');

        let getImgCard
        if (this.dataset.type === 'kit') {
          getImgCard = this.closest('.pr_grid_item').querySelector('img');
        } else {
          getImgCard = this.closest('.card-wrapper').querySelector('.card__inner .card__media img:first-child');
        } 

        if (getModalSrc) {
          const newSrcset = `
            ${getModalSrc}165 165w,
            ${getModalSrc}360 360w,
            ${getModalSrc}533 533w,
            ${getModalSrc}720 720w,
            ${getModalSrc}940 940w,
            ${getModalSrc}1066 1066w,
            ${getModalSrc} 2000w
          `;

          getImgCard?.setAttribute('srcset', newSrcset);
          getImgCard?.setAttribute('src', getModalSrc);
        }

        const newProductInfo = html.querySelector('[id^="ProductInfo"]');
        const oldProductInfo = this.closest('li');

        const updateInnerHTML = (oldElement, newElement) => {
          if (oldElement && newElement) oldElement.innerHTML = newElement.innerHTML;
        };

        const updateDatasetUrl = (oldElement, newElement) => {
          if (oldElement && newElement) oldElement.dataset.url = newElement.dataset.url;
        };

        // update prices
        updateInnerHTML(oldProductInfo.querySelector('.price'), newProductInfo.querySelector('[id^="price-"]'));

        // update title
        if (this.dataset.type === 'kit') {
          updateInnerHTML(oldProductInfo.querySelector('.product-kit-block__main-information .card-information__text a'), newProductInfo.querySelector('.product__title h1'));
        } else {
          updateInnerHTML(oldProductInfo.querySelector('.card > .card__content .card__heading a'), newProductInfo.querySelector('.product__title h1'));
        }
        
        // update data-url of variant selects
        updateDatasetUrl(oldProductInfo.querySelector('variant-selects'), newProductInfo.querySelector('variant-selects'));

        // update variant select size
        updateInnerHTML(oldProductInfo.querySelector('variant-selects .product-form__input.type--tamanho'), newProductInfo.querySelector('variant-selects .product-form__input.type--tamanho'));
        oldProductInfo.querySelector('variant-selects .product-form__input.type--tamanho').classList.add('variants-card')

        // update variant select color
        updateInnerHTML(oldProductInfo.querySelector('variant-selects .product-form__input.type--cor'), newProductInfo.querySelector('variant-selects .product-form__input.type--cor'));

        // update color legend product kit
        if (this.dataset.type == 'kit') {
          updateInnerHTML(oldProductInfo.querySelector('product-group-selects .form__label.label-color'), newProductInfo.querySelector('.main-product__product-group-colors .type--cor .form__label'));
        }

        const allNewVariantsSize = oldProductInfo.querySelectorAll('variant-selects .product-form__input.type--tamanho input[type="radio"]');
        allNewVariantsSize?.forEach((input, index) => {
          input.name = `${this.dataset.section}--${this.dataset.productId}--tamanho`
          input.id = `${this.dataset.section}--${this.dataset.productId}--${index}--tamanho`
        });

        const allNewVariantsColor = oldProductInfo.querySelectorAll('variant-selects .product-form__input.type--cor input[type="radio"]');
        allNewVariantsColor?.forEach((input, index) => {
          input.name = `${this.dataset.section}--${this.dataset.productId}--cor`
          input.id = `${this.dataset.section}--${this.dataset.productId}--${index}--cor`
        });

        const allNewLabelsSize = oldProductInfo.querySelectorAll('variant-selects .product-form__input.type--tamanho label');
        allNewLabelsSize?.forEach((label, index) => label.htmlFor = `${this.dataset.section}--${this.dataset.productId}--${index}--tamanho`);

        const allNewLabelsColor = oldProductInfo.querySelectorAll('variant-selects .product-form__input.type--cor label');
        allNewLabelsColor?.forEach((label, index) => label.htmlFor = `${this.dataset.section}--${this.dataset.productId}--${index}--cor`);

        // update data-url of product info
        updateDatasetUrl(this.closest('[id^="ProductInfo"]'), html.querySelector('[id^="ProductInfo"]'));

        // update pickup availability
        updateInnerHTML(oldProductInfo.querySelector('pickup-availability'), newProductInfo.querySelector('pickup-availability'));

        //update json variants information
        updateInnerHTML(oldProductInfo.querySelector('#card-product-variants-information'), newProductInfo.querySelector('#card-product-variants-information'));

        // update card url
        const getOldLinkCard = oldProductInfo.querySelector('[id^="StandardCardNoMediaLink"]');
        if (getOldLinkCard) getOldLinkCard.href = clickedInput;
        
        // update input id
        if (this.dataset.type === 'kit') {
          const oldProductId = oldProductInfo.querySelector('.product-kit-block__main-information .product-form input[name="id"]');
          const newProductId = newProductInfo.querySelector('.container__buy-buttons input[name="id"]');
          if (oldProductId && newProductId) {
            oldProductId.value = newProductId.value;
            oldProductId.setAttribute('data-name', newProductId.dataset.name);
          }
        } else {
          updateInnerHTML(oldProductInfo.querySelector('.container__buy-buttons input[name="id"]'), newProductInfo.querySelector('.container__buy-buttons input[name="id"]'));
        }

        // update buy button
        updateInnerHTML(oldProductInfo.querySelector('.container__buy-buttons .product-form__buttons'), newProductInfo.querySelector('.container__buy-buttons .product-form__buttons'));

        if (this.dataset.type === 'kit')  this.getProductKitFunctions.initClass();
      });
  }
}

customElements.define('product-group-selects', ProductGroupSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

const megaMenuSummaryAll = document.querySelectorAll('summary.header__menu-item');
const megaMenuHeader = document.querySelector('sticky-header.header-wrapper');
const megaMenuItensAll = document.querySelectorAll('.list-menu--inline>li');
const megaMenuItensAhref = document.querySelectorAll('.list-menu--inline>li:has(>a)');
[...megaMenuSummaryAll,...megaMenuItensAhref].forEach((item)=>{
  item.addEventListener('mouseover',(e)=>{
    megaMenuSummaryAll.forEach((item)=>{
      item.parentNode.removeAttribute('open','');
    })
    item.parentNode.setAttribute('open', '')
  })
})
megaMenuHeader.addEventListener('mouseleave',()=>{
  const details = document.querySelectorAll('details.mega-menu[open]');
  details.forEach((item)=>{
    item.removeAttribute('open')
  })
})
megaMenuHeader.addEventListener('click',(e)=>{
  if(e.target.tagName === "UL" || e.target.tagName === "HEADER" || e.target.tagName === "DIV"){
    megaMenuSummaryAll.forEach((item)=>{
      item.parentNode.removeAttribute('open','');
    })
  }
})

class SliderVertical extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.imageGaleryHeight = document.querySelector('media-gallery slider-component .product-media-container .product__media img').offsetHeight;
    this.style.maxHeight = `${this.imageGaleryHeight}px`;
    this.classList.remove('visibility-hidden');

    this.sliderButtonPrev = this.querySelector('.slider-button--prev');
    this.sliderButtonNext = this.querySelector('.slider-button--next');

    if (this.slider.scrollHeight > this.slider.offsetHeight) {
      this.sliderButtonPrev.classList.remove('hidden');
      this.sliderButtonNext.classList.remove('hidden');

      this.firstItemHeight = this.querySelector('[id^="Slide-"]').offsetHeight;
      this.sliderButtonNext.addEventListener('click', this.moveSlider.bind(this));
      this.sliderButtonPrev.addEventListener('click', this.moveSlider.bind(this));
    }
  }

  moveSlider(event) {
    event.preventDefault();

    const is_next = event.currentTarget.name === 'next' ? true : false;
    this.slideScroll = is_next ? this.slider.scrollTop + this.firstItemHeight : this.slider.scrollTop - this.firstItemHeight;

    this.slider.scrollTo({
      top: this.slideScroll,
      behavior: 'smooth'
    });
  }
}

customElements.define('slider-vertical', SliderVertical);
